import { render, staticRenderFns } from "./noticeForm.vue?vue&type=template&id=f805dce4&scoped=true"
import script from "./noticeForm.vue?vue&type=script&lang=js"
export * from "./noticeForm.vue?vue&type=script&lang=js"
import style0 from "./noticeForm.vue?vue&type=style&index=0&id=f805dce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805dce4",
  null
  
)

export default component.exports